<template>
  <div class="header-wrap">
    <el-container>
      <div class="header-logo">
        <img style="width: 100%; height: 100%;" src="../../assets/img/m-logo.jpg" alt="">
      </div>
      <el-container class="header-left">
        <div class="header-item" @click="toPage('home')" :class="thisPath === '/home' ? 'header-opt' : ''">综合数据</div>
        <div class="header-item" @click="toPage('user')" :class="thisPath !== '/home' ? 'header-opt' : ''">平台管理</div>
      </el-container>
      <div class="header-right">
        <div><span>管理员：</span>{{userName}}</div>
        <el-dropdown class="header-right-text" @command="changeOpt">
          <i class="el-icon-setting header-icon"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">备用</el-dropdown-item>
            <el-dropdown-item :command="2">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      userName: '',
      thisPath: ''
    }
  },
  methods: {
    changeOpt (e) {
      if (e === 2) {
        this.logout()
      }
    },
    toPage (path) {
      this.$router.push({name: path})
    },
    logout () {
      let _this = this
      this.$messageBox.confirm('您确定要退出平台?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$router.push({name: 'login'})
        _this.$store.commit('$_removeStorage')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.userName = JSON.parse(window.sessionStorage.user).nickname
    }
    this.thisPath = this.$route.path
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue